/* eslint-disable */

export const obligatorio = [
    (value: any) => !!value || "Este campo es obligatorio.",
]

export const opcionalNumerico = [
    (value: any) => {
        if (!value) {
            return true;
        }
        return (/^[0-9]+$/.test(value)) || 'Sólo se pueden ingresar números.';
    }
]

export const obligatorioNumerico = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => (/^[0-9]+$/.test(value)) || 'Sólo se pueden ingresar números.'
]

export const obligatorioNumericoSinCero = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => ((Number(value) > 0) && /^[0-9]+$/.test(value)) || 'Sólo se pueden ingresar números mayores a 0.'
]

export const obligatorioMail = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => (/^[a-z0-9._+-]+@[a-z.-]+\.[a-z]+$/i.test(value)) || 'Debe ingresar una dirección de correo válida.'
]

export const opcionalMail = [
    (value : any) => {
        if(!value){
            return true;
        }
        return /^[a-z0-9._+-]+@[a-z.-]+\.[a-z]+$/i.test(value) || 'Debe ingresar una dirección de correo válida.';
    }
]

export const obligatorioAlfabetico = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => (/^[A-Za-zÁÉÍÓÚÜüáéíóúÑñ\s.'-]+$/.test(value)) || 'Sólo se pueden ingresar letras.'
]

export const opcionalAlfaNumerico = [
    (value : any) => {
        if(!value){
            return true;
        }
        return /^[A-Za-zÁÉÍÓÚÜüáéíóúÑñ0-9\s]+$/.test(value) || 'Sólo se pueden ingresar letras y números.';
    }
]

export const obligatorioAlfanumerico = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => (/^[A-Za-zÁÉÍÓÚÜüáéíóúÑñ0-9\s]+$/.test(value)) || 'Sólo se pueden ingresar letras y números.'
]

export const obligatorioAlfanumericoSinCero = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => ((Number(value) > 0) && /^[A-Za-zÁÉÍÓÚÜüáéíóúÑñ0-9\s]+$/.test(value)) || 'Sólo se pueden ingresar letras y números mayores a 0.'
]

export const obligatorioNumeroAfiliado = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => (/^[A-Za-z0-9]+(\/[A-Za-z0-9]+)?$/.test(value)) || 'Caracter inválido.'
]

export const obligatorioCbuOalias = [
    (value : any) => !!value || 'Este campo es obligatorio.',
    (value : any) => (/^[A-Za-zÁÉÍÓÚÜüáéíóúÑñ0-9.\s]+$/.test(value)) || 'Ingrese CBU o alias válido.'
]